import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
// import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Pagination, Autoplay } from "swiper/modules";

export default function SlideShowBanner1st() {
  return (
    
    <Swiper
      modules={[Pagination, Autoplay]}
      slidesPerView={1}
      pagination={{ clickable: true }}
      autoplay={{ delay: 3000 }}
      loop
      className="w-screen custom-swiper"
    >
        <style>
            {`
            .custom-swiper .swiper-pagination {
  bottom: 20px !important;
}

.custom-swiper .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background: #a8a4a4;
  opacity: 0.5;
  transition: all 0.3s ease;
}

.custom-swiper .swiper-pagination-bullet-active {
  width: 50px;
  border-radius: 10px;
  background: #af1a1a; /* golden theme */
  opacity: 1;
}
            `}
        </style>
      

      <SwiperSlide>
        <img
          src="/assets/images/slideshow1st/img-1.jpg"
          className="w-full h-[520px] object-cover"
          alt=""
        />
      </SwiperSlide>

      <SwiperSlide>
        <img
          src="/assets/images/slideshow1st/img-2.jpg"
          className="w-full h-[520px] object-cover"
          alt=""
        />
      </SwiperSlide>
      <SwiperSlide>
        <img
          src="/assets/images/slideshow1st/img-3.jpg"
          className="w-full h-[520px] object-cover"
          alt=""
        />
      </SwiperSlide>
    </Swiper>
  );
}
